import React from 'react';
import { Stack, Title, Text } from '@mantine/core';
import { OsmImportSection } from '../../components/admin/OsmImportSection';
import { RedditCrawlSection } from '../../components/admin/RedditCrawlSection';

/**
 * ImportsPage - Admin-only page for managing data imports
 *
 * Features:
 * - Manual OSM data import for SubAreas
 * - Reddit crawler start/stop controls
 * - Import history and statistics
 *
 * Security:
 * - Admin-only access enforced by route protection
 * - Backend enforces all authorization
 */
export const ImportsPage: React.FC = (): React.ReactElement => {
  return (
    <Stack gap="lg">
      {/* Header */}
      <Stack gap="xs">
        <Title order={1} ff="Comfortaa, sans-serif">
          Data Imports
        </Title>
        <Text c="dimmed" size="lg">
          Manually trigger data imports and manage crawling operations
        </Text>
      </Stack>

      {/* OSM Import Section */}
      <OsmImportSection />

      {/* Reddit Crawl Section */}
      <RedditCrawlSection />
    </Stack>
  );
};
